import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/job-description-analyzer/JDAnalyzerContent.tsx");
